import { useNavigate } from 'react-router-dom'

import overviewJson from '../../demo/fixtures/w2/overview.json'
import { useAiProgress } from '../../demo/selectors'
import { Button, Card, CardHead, Icon, ProgressBar } from '../../ui'
import styles from './CreativeProgressCard.module.css'

interface OverviewFixture {
  creativeProgress: { quota: number }
}

const fixture = overviewJson as unknown as OverviewFixture

export function CreativeProgressCard() {
  const navigate = useNavigate()
  const progress = useAiProgress()
  const quota = fixture.creativeProgress.quota
  const percent = quota === 0 ? 0 : Math.round(progress.made / quota * 100)
  const splits = [
    { key: 'video', icon: 'play' as const, label: '视频', value: progress.video },
    { key: 'image', icon: 'vault' as const, label: '图片', value: progress.image },
  ]

  return (
    <Card className={styles.card} data-scope="overview-progress">
      <CardHead title="素材生成进度" action={<Button className={styles.cardLink} variant="link" onClick={() => { void navigate('/creatives') }}>前往素材库 →</Button>} />
      <div className={styles.body}>
        <div className={styles.top}>
          <span className={styles.number}>{progress.made} / {quota}</span>
          <span className={styles.sub}>本月 AI 已生成素材</span>
        </div>
        <ProgressBar value={percent} />
        <div className={styles.split}>
          {splits.map((item) => (
            <div className={styles.cell} key={item.key}>
              <div className={styles.icon}><Icon name={item.icon} size={17} /></div>
              <div>
                <p className={styles.key}>{item.label}</p>
                <p className={styles.value}>{item.value[0]} / {item.value[1]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  )
}
